import React, { useRef } from 'react';
import '../../../Assets/Css/Award.scss';
import Table from '../../../Components/Table';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import { useEffect } from 'react';
import { customStyle } from '../../../Components/Style';
import { useState } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import qs from 'query-string';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';
import AppreciationIcon from '../../../Assets/Images/Appreciation/Appreciation';
import TrophyIcon from '../../../Assets/Images/Appreciation/Trophy';
import { getAwards, updateAward } from '../../../Services/Award/action';
import { deleteRecord } from '../../../Services/Delete/action';


const Awards = (props) => {
  const [checked, setChecked] = useState(false);
  const [selectedId, setSelectedId] = useState([]);
  const [params, setParams] = useState({});
  const [totalSelectedIds, setTotalSelectedIds] = useState([]);
  const [exportLoading, setExportrLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [inData, setInData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [activeButton, setActiveButton] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const { employeeId } = useParams();
  const fileInputRef = useRef(null);
  const modalRef = useRef(null);

  const navigate = useNavigate();
  const location = useLocation();

  const header = [
    // { field: 'checkbox' },
    { field: 'Title' },
    { field: 'Status' },
    { field: 'Action' },
  ];

  const statusfilter = [
    { value: 'Active', label: 'Active', color: '#679C0D' },
    { value: 'Inactive', label: 'Inactive', color: '#212529' },
  ];

  let footer = true;
  let count = inData?.length;

  useEffect(() => {
    const path = location.pathname;
    setActiveButton(path.split('/').pop());
  }, []);

  useEffect(() => {
    fetchData();
  }, [location.search]);

  const handleClickBtn = (buttonId, route) => {
    setActiveButton(buttonId);
    navigate(route);
  };

  const fetchData = async () => {
    try {
      setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));
      await props.getAwards();
    } catch (error) {
      console.error('Error fetching award:', error);
    }
  };

  const Tableoptions = [
    { value: 'Active', label: 'Active', color: '#679C0D' },
    { value: 'Inactive', label: 'Inactive', color: '#212529' },
  ];

  useEffect(() => {
    props?.award
      ? setInData(
        props?.award?.filter((item) => item?.given_to_employeeId == employeeId)
          ?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          ?.map((item) => {
            return {
              checkbox: {
                value: item?.id,
                type: 'checkbox',
              },
              Title: {
                value: item?.title,
                icon: item?.icon,
                value2: item?.icon_background_color,
                type: 'award',
              },
              Status: {
                value: item?.status,
                type: 'select_option',
              },
              Action: {
                value: `/employees/view/${employeeId}/award/edit`,
                value2: `/employees/view/${employeeId}/award/view`,
                value3: item?.id,
                type: 'action',
              },
              allData: {
                ...item
              }
            };
          })
      )
      : setInData([]);
  }, [props?.award]);

  const handleClose = () => {
    setShowModal(false);
    setFileName('');
    setSelectedFile(null);
    fileInputRef.current.value = null;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose();
        setFileName('');
        setSelectedFile(null);
        fileInputRef.current.value = null;
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClose]);

  const handleChange = (e) => {
    if (e[1] == 'headerAll' && e[0] === true) {
      setTotalSelectedIds([...e[2]]);
    } else if (e[0] === true && e[1] !== 'headerAll') {
      setTotalSelectedIds([...totalSelectedIds, e[1]]);
    } else if (e[1] == 'headerAll' && e[0] === false) {
      setTotalSelectedIds([]);
    } else {
      let filterdId = totalSelectedIds.filter((item) => {
        return item != e[1];
      });
      setTotalSelectedIds(filterdId);
    }
  };

  const handleClick = async (totalSelectedIds, type) => {
    let ids = totalSelectedIds.map((id) => parseFloat(id));

    try {
      if (type === 'delete') {
        setDeleteLoading(true);
        await props.deletePurchaseInvoices(ids);
        setChecked(false);
        setTotalSelectedIds([]);
      } else if (type === 'export') {
        setExportrLoading(true);
        await handlePdfDownload(ids);
        toast.success('Exported Successfully');
      }
    } catch (error) {
      console.error(error);
    } finally {
      await fetchData();
      setDeleteLoading(false);
    }
  };

  useEffect(() => {
    if (totalSelectedIds.length > 0) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [totalSelectedIds]);

  const handleAddClick = () => {
    navigate(`/employees/view/${employeeId}/award/add`);
  };

  const initialState = {
    statusfilter: null,
  };

  const [clientData, setClientData] = useState(initialState);
  const [searchTerm, setSearchTerm] = useState("");

  const applyFilters = ({ status, search }) => {
    const filtered = inData?.filter((leave) => {
      let matchesSearch = true;
      let matchesStatus = true;

      if (status) {
        matchesStatus = leave?.Status?.value?.toLowerCase() === status?.value?.toLowerCase();
      }
      if (search) {
        matchesSearch = leave?.Title?.value?.toLowerCase()?.includes(search?.toLowerCase());
      }
      return matchesSearch && matchesStatus;
    });
    setFilteredData(filtered);
  };

  const handleClear = () => {
    setClientData({
      awardname: "",
      statusfilter: null
    });
    setSearchTerm("");
    setFilteredData([]);
  }

  const searchFiled = (e) => {
    const { name, value } = e.target;
    setClientData((preVal) => ({
      ...preVal,
      [name]: value
    }))
    setSearchTerm(value);
    applyFilters({ status: clientData?.statusfilter, search: value });
  }


  return (
    <div className="award-main">
      <div className="row">
        <div className="page-title">
          <h4> Award </h4>
          <button className="custom-award-btn" disabled={props.loading} onClick={handleAddClick}>
            {props.loading ? (
              <Spinner as="span" animation="border" role="status" aria-hidden="true" />
            ) : (
              'Add Award'
            )}
          </button>
        </div>

        <div className="col-lg-4">
          <div className="input-group">
            <Select
              options={statusfilter}
              styles={{
                ...customStyle,
                menu: (provided) => ({
                  ...provided,
                  zIndex: 2,
                }),
              }}
              value={clientData.statusfilter}
              placeholder="Status"
              onChange={(val) => {
                setClientData((preVal) => ({
                  ...preVal,
                  statusfilter: val,
                }));
                applyFilters({ status: val, search: searchTerm });
              }}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: '#5757fe',
                  primary: '#5757fe',
                },
              })}
            />
          </div>
        </div>

        <div className="col-lg-4">
          <div className="input-group">
            <input
              type="text"
              className="input-css"
              name="awardname"
              placeholder="Search"
              onChange={searchFiled}
            />
          </div>
        </div>
      </div>

      <div className="gap-4 addaward-export-btn">
        <div>
          {(searchTerm || filteredData?.length > 0 || clientData?.statusfilter) && (
            <button
              className="custom-award-btn"
              disabled={props.loading}
              onClick={handleClear}
            >
              {props.loading ? (
                <Spinner as="span" animation="border" role="status" aria-hidden="true" />
              ) : (
                'Clear'
              )}
            </button>
          )}
        </div>

        <div>
          <div className="navigation_btn">
            <button
              className={`btn1 ${activeButton === 'appreciation' ? 'active' : ''}`}
              onClick={() => handleClickBtn('appreciation', `/employees/view/${employeeId}/appreciation`)}
            >
              <AppreciationIcon
                color={activeButton === 'appreciation' ? 'white' : 'black'}
                bgColor={activeButton === 'appreciation' ? 'black' : 'transparent'}
              />
            </button>
            <button
              className={`btn1 ${activeButton === 'award' ? 'active' : ''}`}
              onClick={() => handleClickBtn('award', `/employees/view/${employeeId}/award`)}
            >
              <TrophyIcon
                color={activeButton === 'award' ? 'white' : 'black'}
                bgColor={activeButton === 'award' ? 'black' : 'transparent'}
              />
            </button>
          </div>
        </div>
      </div>

      <div className="invoice-table-part" style={{ marginBottom: "15px", marginTop: "15px" }}>
        <Table
          header={header}
          data={(searchTerm || clientData?.statusfilter) ? filteredData : inData}
          footer={footer}
          count={count}
          checked={checked}
          records={count}
          totalSelectedIds={totalSelectedIds}
          defaultParams={params}
          selectedId={selectedId}
          handleChange={handleChange}
          showIsDelete={true}
          showIsEdit={true}
          Tableoptions={Tableoptions}
          updateAward={props?.updateAward}
          deleteRecord={props?.deleteRecord}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.awardReducer.loading,
    award: state.awardReducer.award,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAwards: () => {
      dispatch(getAwards());
    },
    updateAward: (id, data) => {
      dispatch(updateAward(id, data))
    },
    deleteRecord: async (id, inputValue) => {
      await dispatch(deleteRecord(id, inputValue))
      await dispatch(getAwards());
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Awards);
